import React, {Component} from 'react'
import spinner from '../spinner.gif'

const LoadingHOC = (WrappedState) =>{
  return(
    class LoadingHOC extends Component{
      render(){
        return this.props.store.length === 0 ? <img className="isLoading" src={spinner}/> : <WrappedState {...this.props}/>
      }
    }
  )
}

export default LoadingHOC



// WEBPACK FOOTER //
// ./src/components/LoadingHOC.js